var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods_list"},_vm._l((_vm.item),function(it,i){return _c('goods-item',{key:i,attrs:{"item":it}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }